import type { MessageOut } from "@/api/types/studio";

/**
 * True when the assistant still owes a reply: the summary counts
 * unprocessed people messages and the thread's newest message is from a
 * person (author owner/admin). Messages are ordered oldest→newest, so an
 * assistant message newer than the last person message lands last and ends
 * the wait. Empty thread or no summary → not waiting.
 */
export function waitingForAssistant(
  messages: readonly MessageOut[],
  summary: { unprocessed_from_people: number } | undefined,
): boolean {
  if (!summary || summary.unprocessed_from_people <= 0) return false;
  const last = messages[messages.length - 1];
  return !!last && last.author !== "assistant";
}
